import AddCourseModal from 'modules/courses/bundles/course-bundle/components/add-course-modal'
import { CourseBundleItemInterface } from 'modules/courses/bundles/course-bundle/types/course-bundle-interface'
import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { EmptyListIcon } from '@systemeio/ui'

interface CourseBundleEmptyListInterface {
  addCourseWithUpdate: (course: CourseBundleItemInterface) => Promise<void>
  courseBundleId: string
  disabled: boolean
}

const CourseBundleEmptyList = ({
  addCourseWithUpdate,
  courseBundleId,
  disabled,
}: CourseBundleEmptyListInterface) => {
  const { t } = useLocoTranslation()
  return (
    <div className="bg-background-secondary mt-5 flex w-full flex-col items-center justify-center gap-3 rounded-lg py-20">
      <EmptyListIcon />
      <div className={`flex flex-col items-center`}>
        <span className={'text-text-primary text-base'}>{t('dashboard.list.empty_title')}</span>
        <span className={'text-text-primary text-base'}>{t('dashboard.list.empty_list')}</span>
      </div>
      <AddCourseModal
        addCourseWithUpdate={addCourseWithUpdate}
        courseBundleId={courseBundleId}
        disabled={disabled}
        withIcon={false}
      />
    </div>
  )
}

export default CourseBundleEmptyList
